require("@nprapps/sidechain");
require("./cb-newsletter");
require("./audio-player");

var shareButton = document.querySelector("button.share");
if ("share" in navigator) {
  shareButton.toggleAttribute("hidden", false);
  shareButton.addEventListener("click", () => {
    navigator.share({
      url: window.location.href,
      title: `Chalkbeat Chicago: ${document.title}`,
      text: `${document.title}: ${window.location.href}`
    });
  });
}